var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSfxLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 399,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.851 201.117v122.198c0 8.54-6.856 15.453-15.311 15.453h-25.942a1.538 1.538 0 01-1.532-1.545V215.025c0-8.535 6.852-15.453 15.311-15.453h25.943a1.54 1.54 0 011.531 1.545z",
    fill: "url(#sfx-logo_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.744 15.45v143.023c0 .849-.681 1.545-1.532 1.545H88.113c-8.463 0-15.315-6.922-15.315-15.453V1.541c0-.854.68-1.541 1.531-1.541h26.099c8.464 0 15.316 6.914 15.316 15.45z",
    fill: "url(#sfx-logo_svg__paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.744 272.93v109.934c0 8.531-6.852 15.449-15.316 15.449H74.329a1.535 1.535 0 01-1.531-1.546V286.838c0-8.536 6.852-15.454 15.315-15.454h26.099c.851 0 1.532.696 1.532 1.546z",
    fill: "url(#sfx-logo_svg__paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.82 310.741v72.122c0 8.531-6.851 15.449-15.306 15.449H1.532A1.535 1.535 0 010 396.767v-72.122c0-8.536 6.856-15.454 15.316-15.454h25.973c.85 0 1.532.696 1.532 1.55z",
    fill: "url(#sfx-logo_svg__paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.851 75.817v62.646c0 .854-.681 1.55-1.531 1.55h-25.943c-8.459 0-15.311-6.918-15.311-15.454v-62.65c0-.85.686-1.546 1.532-1.546h25.942c8.451 0 15.311 6.918 15.311 15.454z",
    fill: "url(#sfx-logo_svg__paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.822 15.454v72.13c0 .854-.681 1.546-1.532 1.546H15.316C6.857 89.13.001 82.212.001 73.685V1.545c0-.854.685-1.54 1.532-1.54h25.982c8.455 0 15.306 6.913 15.306 15.449z",
    fill: "url(#sfx-logo_svg__paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 396.826V294.118c0-9.833-3.87-19.268-10.757-26.222-12.517-12.629-25.033-25.245-37.55-37.875-6.892-6.95-16.233-10.858-25.978-10.858h-101.78a1.54 1.54 0 00-1.532 1.545v102.704c0 9.837 3.869 19.272 10.761 26.226 12.517 12.625 25.025 25.246 37.541 37.871 6.892 6.954 16.234 10.863 25.978 10.863h101.785c.846 0 1.532-.696 1.532-1.546z",
    fill: "url(#sfx-logo_svg__paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 1.549v102.708c0 9.833-3.87 19.268-10.757 26.222-12.517 12.63-25.033 25.246-37.55 37.875-6.892 6.95-16.233 10.858-25.978 10.858h-101.78a1.54 1.54 0 01-1.532-1.545V74.963c0-9.837 3.869-19.272 10.761-26.226 12.517-12.625 25.025-25.246 37.541-37.87C271.597 3.911 280.939.003 290.683.003h101.785c.846 0 1.532.695 1.532 1.545z",
    fill: "url(#sfx-logo_svg__paint7_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sfx-logo_svg__paint0_linear",
    x1: 140.772,
    y1: 200.024,
    x2: 207.938,
    y2: 331.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sfx-logo_svg__paint1_linear",
    x1: 68.487,
    y1: 0.52,
    x2: 151.566,
    y2: 142.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sfx-logo_svg__paint2_linear",
    x1: 68.487,
    y1: 271.797,
    x2: 126.21,
    y2: 396.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sfx-logo_svg__paint3_linear",
    x1: -4.298,
    y1: 309.481,
    x2: 27.037,
    y2: 405.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sfx-logo_svg__paint4_linear",
    x1: 140.772,
    y1: 60.622,
    x2: 166.314,
    y2: 148.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sfx-logo_svg__paint5_linear",
    x1: -4.297,
    y1: 0.294,
    x2: 27.041,
    y2: 96.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sfx-logo_svg__paint6_linear",
    x1: 198.576,
    y1: 219.745,
    x2: 231.557,
    y2: 428.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sfx-logo_svg__paint7_linear",
    x1: 198.576,
    y1: 0.586,
    x2: 231.557,
    y2: 208.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}

export default SvgSfxLogo;